import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarCotasByAptoService } from "../services/buscarCotasByAptoService";

// --------------------- Import Interfaces ---------------------

export const useBuscarCotas = (aptoId: number | undefined | null) => {
  const [cotas, setCotas] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Evita chamar o serviço se aptoId for null ou undefined
    if (aptoId === null || aptoId === undefined) {
      setCotas([]); // Limpa as cotas se não houver ID válido
      setIsLoading(false);
      return;
    }

    const fetchCotas = async () => {
      setIsLoading(true); // Garante o estado de loading ao iniciar a busca
      try {
        const data = await buscarCotasByAptoService(aptoId);
        setCotas(data);
      } catch (error) {
        console.error("Erro ao buscar cotas:", error);
        setCotas([]); // Define um estado padrão em caso de erro
      } finally {
        setIsLoading(false); // Finaliza o loading
      }
    };

    fetchCotas();
  }, [aptoId]);

  return { cotas, isLoading };
};
